import React, { useContext, useRef, useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

import CargandoDatosLoader from '../components/CargandoDatosLoader'
import Pesos from '../components/Pesos'

import { StepContext } from '../StepContext'
import { traerDatosEpagos, requestConfirmarDDJJ } from '../utils/requests'

const total = (acc, cur) => acc + cur.total

function CustomCol({ title, strong, pesos }) {
  return (
    <Col className="mt-3 d-flex align-items-center justify-content-center">
      {title && strong ? <strong>{title}</strong> : title}
      {(pesos || pesos === 0) && <Pesos value={pesos} />}
    </Col>
  )
}

const EmisionDeclaracionJurada = () => {
  const { setPuedeAvanzar, setCallback } = useContext(StepContext)
  const linkRef = useRef()
  const [tshID, setTshID] = useState(0)
  const [loading, setLoading] = useState(true)
  const [cargandoDDJJ, setCargandoDDJJ] = useState(false)
  const [errorDDJJ, setErrorDDJJ] = useState(false)
  const [avanzar, setAvanzar] = useState(false)
  const [modalShow, setModalShow] = useState(false)
  const [datos, setDatos] = useState({})
  const [totales, setTotales] = useState([])
  const [errorEpagosService, setErrorEpagosService] = useState(false)
  const [datosEpagos, setDatosEpagos] = useState({
    version: '',
    url: '',
    token: '',
    idOrganismo: '',
    nombre: '',
    apellido: '',
    cuit: '',
    cb: '',
    url_ok: '',
    url_error: ''
  })

  useEffect(() => {
    let posible = true

    fetch('/ddjj/api/tshID')
      .then((res) => res.json())
      .then((res) => {
        if (posible) {
          setTshID(res.tshID)
        }
      })

    return () => {
      posible = false
    }
  }, [setTshID])

  useEffect(() => {
    setPuedeAvanzar(avanzar && totales[2] > 0)
    setCallback(goToEpagos)
  }, [avanzar, setPuedeAvanzar, setCallback, totales])

  useEffect(() => {
    if (!checkDatosEpagosVacios(datosEpagos) && !loading) {
      sendFormulario()
    }
  }, [datosEpagos, loading])

  const checkDatosEpagosVacios = (obj) => {
    for (var key in obj) {
      if (obj[key] !== null && obj[key] !== '') return false
    }
    return true
  }

  const goToEpagos = () => {
    traerDatosEpagos()
      .then(({ status, content }) => {
        if (status === 200) {
          setDatosEpagos(content)
        } else {
          setErrorEpagosService(content)
        }
      })
      .catch((err) => {
        console.log(err)
      })

    //Esta parte no darle bola.
    return new Promise((resolve, _) => {
      resolve(true)
    }).then((ok) => {
      return ok
    })
  }

  const confirmarDDJJ = () => {
    setCargandoDDJJ(true)
    setErrorDDJJ(false)
    requestConfirmarDDJJ()
      .then(({ status, content }) => {
        if (status === 200) {
          setAvanzar(true)
          setModalShow(false)
          setPuedeAvanzar(true)
        } else {
          setErrorDDJJ(true)
        }
      })
      .catch((e) => {
        setCargandoDDJJ(false)
        setErrorDDJJ(true)
      })
      .finally(() => setCargandoDDJJ(false))
  }

  const sendFormulario = () => {
    let formulario = document.forms.namedItem('f')
    formulario.submit()
  }

  useEffect(() => {
    let posible = true
    setLoading(true)

    if (posible) {
      fetch('/ddjj/api/emision-ddjj')
        .then((res) => res.json())
        .then((data) => {
          const pagar =
            data?.imponibles?.reduce(total, 0) -
            //data?.deducciones?.reduce(total, 0) -
            data?.retenciones?.reduce(total, 0)
          const pagado = data?.abonado?.reduce(total, 0)

          setTotales([pagar, pagado, pagar - pagado])
          setDatos(data)
          setLoading(false)
        })
    }

    return () => {
      posible = false
    }
  }, [setDatos, setLoading, setTotales])

  const formulario = () => {
    const totalAbonar = totales[2]
    const detalleOperacion = encodeURI(
      JSON.stringify([
        {
          id_item: '0',
          desc_item: `DDJJ Anual TISH - ${datosEpagos.cuit}:`,
          monto_item: totalAbonar,
          cantidad_item: 1
        }
      ])
    )
      .replace(/:/g, '%3A')
      .replace(/%20/g, '+')
      .replace(/,/g, '%2C')
    return (
      <form name="f" method="post" action={datosEpagos.url} target="_blank">
        <input type="hidden" name="version" value="2.0" />
        <input type="hidden" name="operacion" value="op_pago" />
        <input
          type="hidden"
          name="id_organismo"
          value={datosEpagos.idOrganismo}
        />
        <input type="hidden" name="convenio" value="" />
        <input type="hidden" name="token" value={datosEpagos.token} />
        <input
          type="hidden"
          name="identificador_externo"
          value={datosEpagos.cuit}
        />
        <input
          type="hidden"
          name="identificador_externo_2"
          value={datosEpagos.cb}
        />
        <input
          type="hidden"
          name="identificador_externo_3"
          value={datosEpagos.id_boleta}
        />
        <input type="hidden" name="id_moneda_operacion" value="1" />
        <input type="hidden" name="monto_operacion" value={totalAbonar} />
        <input
          type="hidden"
          name="detalle_operacion"
          value={detalleOperacion}
        />
        <input type="hidden" name="detalle_operacion_visible" value="1" />
        <input type="hidden" name="nombre_pagador" value={datosEpagos.nombre} />
        <input
          type="hidden"
          name="apellido_pagador"
          value={datosEpagos.apellido}
        />
        <input type="hidden" name="tipo_doc_pagador" value="9" />
        <input
          type="hidden"
          name="numero_doc_pagador"
          value={datosEpagos.cuit}
        />
        <input type="hidden" name="ok_url" value={datosEpagos.url_ok} />
        <input type="hidden" name="error_url" value={datosEpagos.url_error} />
      </form>
    )
  }

  const AlertaEpagosService = () => (
    <Alert variant={'primary'} style={{ textAlign: 'center' }}>
      <Alert.Heading>Error Epagos</Alert.Heading>
      {errorEpagosService.error}
    </Alert>
  )

  const dataCuit = datos?.dataLegajos?.filter(
    (DatoActual, PosicionActual, arry) =>
      !PosicionActual || DatoActual.legajo !== arry[PosicionActual - 1].legajo
  )
  const legajos = dataCuit?.map((data) => data.legajo)

  return (
    <>
      {errorEpagosService ? (
        <div style={{ marginBottom: '40px' }}>
          <AlertaEpagosService />
        </div>
      ) : (
        <CargandoDatosLoader cargando={loading}>
          {legajos?.map((legajo) => (
            <React.Fragment key={legajo}>
              <h6 className="text-muted text-normal text-uppercase">{`Legajo ${legajo}`}</h6>
              <hr className="mb-4" />
              <Container
                className="d-flex justify-content-around"
                key={`legajo${legajo}`}
              >
                <Row className="flex-column">
                  {datos?.imponibles
                    ?.filter((item) => item.legajo === legajo)
                    ?.map((dato, index) => {
                      const deduccionPorLegajo = datos?.deducciones
                        ?.filter(
                          (item) =>
                            item.legajo === legajo &&
                            item.bimestre === index + 1
                        )
                        .reduce((acc, curr) => acc + curr.total, 0)
                      return (
                        <React.Fragment key={`${legajo}_imponibles_${index}`}>
                          <CustomCol
                            strong={true}
                            title={`Bimestre N° ${index + 1} Total`}
                          />
                          <CustomCol
                            pesos={dato.total - (deduccionPorLegajo || 0)}
                          />
                        </React.Fragment>
                      )
                    })}
                </Row>
                <Row className="flex-column">
                  {datos?.abonado
                    ?.filter((item) => item.legajo === legajo)
                    .map((dato, index) => (
                      <React.Fragment
                        key={`${legajo}_abonados_${dato.bimestre}`}
                      >
                        <CustomCol
                          strong={true}
                          title={`Bimestre N° ${dato.bimestre} Total Abonado`}
                        />
                        <CustomCol pesos={dato.total} />
                      </React.Fragment>
                    ))}
                </Row>
                <Row className="flex-column">
                  {datos?.imponibles
                    ?.filter((item) => item.legajo === legajo)
                    .map((dato, index, array) => {
                      const retencionPorLegajo = datos?.retenciones
                        ?.filter(
                          (item) =>
                            item.legajo === legajo &&
                            item.bimestre === index + 1
                        )
                        .reduce((acc, curr) => acc + curr.total, 0)
                      const abonadoPorLegajo = datos?.abonado
                        ?.filter(
                          (item) =>
                            item.legajo === legajo &&
                            item.bimestre === index + 1
                        )
                        .reduce((acc, curr) => acc + curr.total, 0)
                      const dif =
                        dato.total -
                        (retencionPorLegajo || 0) -
                        (abonadoPorLegajo || 0)
                      return (
                        <React.Fragment key={`${legajo}_diferencias_${index}`}>
                          <CustomCol
                            strong={true}
                            title={`Bimestre N° ${index + 1} Diferencia`}
                          />
                          <CustomCol pesos={dif} />
                        </React.Fragment>
                      )
                    })}
                </Row>
              </Container>
              <br />
            </React.Fragment>
          ))}
          <hr className="my-1" />

          <Row className="container" style={{ paddingTop: 50 }}>
            {[
              'Total Anual',
              'Total Abonado Anual',
              'Total Diferencia Anual'
            ].map((t, i) => (
              <CustomCol key={i} strong={true} title={t} />
            ))}
          </Row>

          <Row className="container">
            {totales?.map((t, i) => (
              <CustomCol key={i} pesos={t} />
            ))}
          </Row>

          <hr className="my-4" />

          {totales.slice(-1)[0] < 0 ? (
            <Row className="container align-items-center my-5 flex-column">
              <CustomCol strong title="Crédito a favor" />
              <CustomCol pesos={totales.slice(-1)[0] * -1} />
            </Row>
          ) : (
            <></>
          )}

          <Row className="container justify-content-center align-items-center my-5 flex-column">
            <CustomCol strong={true} title="Total a pagar" />
            <CustomCol
              pesos={totales.slice(-1)[0] < 0 ? 0 : totales.slice(-1)[0]}
            />
            <Button
              disabled={avanzar}
              variant="primary"
              className="my-5"
              onClick={() => setModalShow(true)}
            >
              {avanzar ? 'Declaracion Jurada Presentada.' : 'Confirmar'}
            </Button>

            <a style={{ display: 'none' }} ref={linkRef} href="/#">
              #
            </a>

            {avanzar && (
              <Button
                variant="outline-primary"
                onClick={() =>
                  fetch('/ddjj/api/emision-ddjj/declaracion')
                    .then((res) => res.blob())
                    .then((blob) => {
                      const href = window.URL.createObjectURL(blob)
                      const a = linkRef.current
                      a.download = `Declaración Jurada - ${tshID}.pdf`
                      a.href = href
                      a.click()
                      a.href = ''
                    })
                    .catch((err) => console.log(err))
                }
              >
                Descargar PDF
              </Button>
            )}
          </Row>

          <Modal
            size="xs"
            centered
            show={modalShow}
            onHide={() => setModalShow(false)}
          >
            <Modal.Header closeButton />
            <Modal.Body>
              Se van a guardar todos los datos ingresados ¿esta de acuerdo?
              {errorDDJJ && (
                <p style={{ color: 'red' }}>
                  Ha ocurrido un error. Por favor contacte con el municipio o
                  intente nuevamente.
                </p>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="danger" onClick={() => setModalShow(false)}>
                Cancelar
              </Button>
              <Button
                variant="primary"
                disabled={cargandoDDJJ || errorDDJJ}
                onClick={() => confirmarDDJJ()}
              >
                {cargandoDDJJ ? 'Cargando...' : 'Aceptar'}
              </Button>
            </Modal.Footer>
          </Modal>

          {formulario()}
        </CargandoDatosLoader>
      )}
    </>
  )
}

export default EmisionDeclaracionJurada
